// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-logo img {\r\n    height: 48px;\r\n    width: 35px;    \r\n}", ""]);
// Exports
module.exports = exports;
